<template>

    <div v-if="data" class="contentWrapper" v-bind:style="{ width: settings.width+'%' }">

        <div class="prop-wrap">

            <div :class="[{'bordered':  settings.isBordered }, 'prop-inner']" v-if="contentElementData.length > 0">

                <span class="type" v-if="contentElementData[0].value">{{ contentElementData[0].value }}</span>

                <!-- Header -->
                <div class="contentHeader">

                    <span v-if="contentElementData[1].value">{{ contentElementData[1].value }}</span>
                    <div class="avatar" v-bind:style='{ backgroundImage: imageUrl }'></div>

                    <!--
                    <div class="imgWrapper has-text-centered" v-if="contentElementData[1].assets && contentElementData[1].assets[0].asset != undefined">
                        <img class="lazy-img-fadein" v-lazy="$config.assets + contentElementData[1].assets[0].asset.path + '/' + contentElementData[1].assets[0].asset.filename"/>
                    </div>
                    -->

                    <span class="author" v-if="contentElementData[2].value">{{ contentElementData[2].value }}</span>

                    <h1 class="title" v-if="contentElementData[3].value">{{ contentElementData[3].value }}</h1>
                </div>



                <!-- BODY -->
                <div class="contentBody" v-if="contentElementData[4].value">{{ contentElementData[4].value }}</div>

                <!-- FOOTER -->
                <div class="contentFooter">

                </div>


            </div>

        </div>

    </div>

</template>


<script>

export default {

    props: ['data', 'settings'],

    data(){
		return {
            contentElementData: []
		}
	},

    created() {

        this.contentElementData = this.data.contentElement.contentElementData;

    },

    mounted() {

   },

    updated() {

        $('.contentWrapper').flowtype({
            minFont : 2,
            fontRatio: 20
        });

    },

    computed: {

        imageUrl() {

            if(this.contentElementData[1].assets[0]) {
                return 'url(' + this.$config.assets + this.contentElementData[1].assets[0].asset.path + '/' + this.contentElementData[1].assets[0].asset.filename+ ')';
            } else {
                return '';
            }

        }

    },

    methods: {

    }


}

</script>




<style scoped>

.author {
    display: inline-block;
    margin: 4% 0 10% 0;
}
span.type {
    display: block;
    margin: 0 auto;
    font-size: 130%;
    font-weight: 400;
    font-style: italic;
    text-align: center !important;
}


/* header */
.contentHeader {
    z-index: 999;
    margin: 0 0 4% 0;
    width: 100%;
}
.contentHeader .author {
    font-size: 80%;
}
.contentHeader h2 {
    font-size: 145%;
    margin: 8% 0 0 0;
    padding: 0;
}


/* body */
.contentBody {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: inherit;
    overflow: hidden;
    font-size: 100%;
}

.avatar {
    margin: 5% auto 0 auto;
    background-repeat: no-repeat;
    width: 3.8vw;
    height: 3.8vw;
    background-size: cover;
    background-position: center;
    border-radius: 50%;
}

</style>
